/**
 * PC端路由错误处理工具
 * 用于全局处理路由导航错误，特别是导航重复错误
 */

/**
 * 设置全局路由错误处理
 * @param {Object} router - Vue Router实例
 */
export function setupRouterErrorHandler(router) {
  // 处理路由错误
  router.onError((error) => {
    // 处理导航重复错误
    if (error.name === 'NavigationDuplicated' || error.message?.includes('Avoided redundant navigation')) {
      console.log('导航重复，已忽略')
      return
    }
    
    // 处理导航取消错误（通常发生在快速切换路由时）
    if (error.name === 'NavigationCancelled' || (error.message && error.message.includes('Navigation cancelled'))) {
      console.log('导航被取消，已忽略')
      return
    }
    
    // 记录其他未知错误
    console.error('未知路由错误:', error)
  })
}

/**
 * 安全的路由跳转包装器
 * @param {Object} router - Vue Router实例
 * @param {string|Object} route - 目标路由
 * @param {Function} onSuccess - 成功回调
 * @param {Function} onError - 错误回调
 */
export function safePush(router, route, onSuccess, onError) {
  router.push(route).then(() => {
    if (onSuccess) onSuccess()
  }).catch((error) => {
    // 忽略导航重复和导航取消错误
    if (error.name === 'NavigationDuplicated' || error.name === 'NavigationCancelled' || 
        error.message?.includes('Avoided redundant navigation') || 
        error.message?.includes('Navigation cancelled')) {
      console.log('导航重复或取消，已忽略')
      if (onSuccess) onSuccess()
    } else {
      console.error('路由跳转失败:', error)
      if (onError) onError(error)
    }
  })
}

/**
 * 安全的路由替换包装器
 * @param {Object} router - Vue Router实例
 * @param {string|Object} route - 目标路由
 * @param {Function} onSuccess - 成功回调
 * @param {Function} onError - 错误回调
 */
export function safeReplace(router, route, onSuccess, onError) {
  router.replace(route).then(() => {
    if (onSuccess) onSuccess()
  }).catch((error) => {
    // 忽略导航重复和导航取消错误
    if (error.name === 'NavigationDuplicated' || error.name === 'NavigationCancelled' || 
        error.message?.includes('Avoided redundant navigation') || 
        error.message?.includes('Navigation cancelled')) {
      console.log('导航重复或取消，已忽略')
      if (onSuccess) onSuccess()
    } else {
      console.error('路由替换失败:', error)
      if (onError) onError(error)
    }
  })
} 